export default __webpack_public_path__ + "static/media/method-m2.83ef24e0.svg";